import { render, staticRenderFns } from "./CODrearrange.vue?vue&type=template&id=1309af67&scoped=true"
import script from "./CODrearrange.vue?vue&type=script&lang=js"
export * from "./CODrearrange.vue?vue&type=script&lang=js"
import style0 from "./CODrearrange.vue?vue&type=style&index=0&id=1309af67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1309af67",
  null
  
)

export default component.exports